(function () {
  var sesamiBundleSrc = 'https://cdn.sesami.co/storefront/latest/sesami-main.js';
  var fallbackLoaded = false;

  function hasSesamiTag() {
    return Boolean(document.querySelector('sesami-experience, sesami-warning'));
  }

  function sesamiIsReady() {
    return Boolean(window.customElements && window.customElements.get && window.customElements.get('sesami-experience'));
  }

  function loadSesamiFallback() {
    if (fallbackLoaded || !hasSesamiTag() || sesamiIsReady()) return;
    if (document.querySelector('script[src="' + sesamiBundleSrc + '"]')) {
      fallbackLoaded = true;
      return;
    }

    fallbackLoaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = sesamiBundleSrc;
    document.head.appendChild(script);
  }

  function getSubmitButton() {
    return document.querySelector('.product-form__submit');
  }

  function getProductForm() {
    var button = getSubmitButton();
    return button ? button.closest('form') : null;
  }

  function hasReservation() {
    var form = getProductForm();
    if (!form) return false;

    var token = form.querySelector('[sesami-hidden-reservation-token], [name="properties[_reservation_token]"]');
    var date = form.querySelector('[sesami-hidden-date], [name^="properties["][name$="Date]"], [name^="properties["][name$="Fecha]"]');

    return Boolean(
      (token && token.value && token.value.trim()) ||
      (date && date.value && date.value.trim())
    );
  }

  function setLocked(locked) {
    var button = getSubmitButton();
    if (!button) return;

    if (locked) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.dataset.sesamiLocked = 'true';
      return;
    }

    if (button.dataset.sesamiLocked === 'true') {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      delete button.dataset.sesamiLocked;
    }
  }

  function refreshLock() {
    if (!document.querySelector('sesami-experience')) return;
    loadSesamiFallback();
    setLocked(!hasReservation());
  }

  function watchHiddenFields() {
    var form = getProductForm();
    if (!form) return;

    form.querySelectorAll('.sesami-hidden-field, [sesami-hidden-date], [sesami-hidden-time], [sesami-hidden-reservation-token]').forEach(function (field) {
      if (field.dataset.sesamiWatched === 'true') return;
      field.dataset.sesamiWatched = 'true';
      field.addEventListener('change', refreshLock);
      field.addEventListener('input', refreshLock);
    });
  }

  function refreshSoon() {
    window.setTimeout(function () {
      loadSesamiFallback();
      watchHiddenFields();
      refreshLock();
    }, 0);
    window.setTimeout(function () {
      loadSesamiFallback();
      watchHiddenFields();
      refreshLock();
    }, 500);
  }

  document.addEventListener('DOMContentLoaded', refreshSoon);
  window.setTimeout(loadSesamiFallback, 1500);
  window.setTimeout(loadSesamiFallback, 4000);
  window.addEventListener('sesami:loaded', refreshSoon);
  window.addEventListener('sesami:modal:opened', refreshSoon);
  window.addEventListener('sesami:modal:closed', refreshSoon);
  window.addEventListener('sesami:reservation:success', refreshSoon);
  window.addEventListener('sesami:booking:success', refreshSoon);

  document.addEventListener('submit', function (event) {
    if (!document.querySelector('sesami-experience') || hasReservation()) return;
    var form = getProductForm();
    if (form && event.target === form) {
      event.preventDefault();
      event.stopPropagation();
      refreshLock();
    }
  }, true);

  new MutationObserver(function () {
    refreshSoon();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
